import {LOAD_HUSN} from "../../types";

import axios from "axios";

const LoadHusn = () => {
    return (dispatch) => {
        const HusnUrl = "https://www.hisnmuslim.com/api/ar/husn_ar.json";
        axios.get(HusnUrl).then(response => {
            dispatch({
                type: LOAD_HUSN,
                payload: Object.values(response.data)[0]
            })
        }).catch(err => console.log("err from husn" + err));
    }
}

export default LoadHusn;